import { useEffect } from 'react';
import { useModal } from "../contexts";
import { getAuthToken, getRefreshToken, setAuthToken, setRefreshToken } from '../auth';
import ReloadModal from './ReloadModal';
import { isTokenValid } from '../utils';
import { postData } from '../backend';
import jwt_decode from "jwt-decode";

function SessionManager() {

  const { openModal } = useModal();

  useEffect(() => {
    const checkAndRefreshToken = () => {
      const token = getAuthToken();
      if (!token)
        return openModal(<ReloadModal />);

      const payload: any = jwt_decode(token);
      const exp = new Date(payload.exp * 1000);

      if (exp.getTime() >= new Date().getTime() - 1000 * 60 * 60) // 1 hour before expiration
        return;

      const refreshToken = getRefreshToken();
      if (!isTokenValid(refreshToken))
        return openModal(<ReloadModal />);

      postData("/auth/token-refresh/", { refreshToken })
        .then(({ token: authToken, refreshToken }) => {
          setAuthToken(authToken);
          setRefreshToken(refreshToken);
        })
        .catch(() => openModal(<ReloadModal />));
    }

    checkAndRefreshToken();

    const timer = setInterval(checkAndRefreshToken, 1000 * 60); // Check every minute
    return () => clearTimeout(timer);
  }, [openModal]);

  return null;
}

export default SessionManager;
